import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import EmployeesIcon from '../../../../components/activeIcons/EmployeesIcon';
import { BankInfo } from '../../../../components/custom/BankInfo';
import { FundLogo } from '../../../../components/custom/FundLogo';
import {
  extractFundNumber,
  formatMoney,
} from '../../../../utils/format/format';
import PaymentSidebar from './PaymentSidebar';
import { useState } from 'react';

interface PaymentItemProps {
  deposit: any;
}

const PaymentItem: React.FC<PaymentItemProps> = ({ deposit }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleOpenPaymentSidebar = () => {
    setSidebarOpen(true);
  };

  const handleClosePaymentSidebar = () => {
    setSidebarOpen(false);
  };

  const calculateUniqueEmployees = (employees: any) => {
    if (!Array.isArray(employees) || employees.length === 0) {
      return 0;
    }

    const uniqueEmployeeIds = new Set();

    employees.forEach((employee) => {
      if (employee && employee.employeeId) {
        uniqueEmployeeIds.add(employee.employeeId);
      }
    });

    return uniqueEmployeeIds.size;
  };

  const uniqueCount = calculateUniqueEmployees(deposit?.employees);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          p: '30px',
          borderRadius: '10px',
          backgroundColor: '#FFF',
          cursor: 'pointer',
          direction: 'rtl',
          position: 'relative',
        }}
        onClick={handleOpenPaymentSidebar}
      >
        {deposit?.paymentMethodCode === '6' && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: 'auto',
              height: 'auto',
              zIndex: 1,
            }}
          >
            <img
              src="/assets/noPayment.svg"
              alt="No Payment"
              style={{ display: 'block' }}
            />
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            flexDirection: 'row-reverse',
          }}
        >
          <FundLogo
            width="100px"
            height="50px"
            fundNumber={deposit?.fundIdentifier}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '20px',
            flexDirection: 'row-reverse',
          }}
        >
          <EmployeesIcon number={uniqueCount} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '22px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography
                textAlign={'right'}
                fontWeight={'700'}
                fontSize={'16px'}
                fontFamily={'AlmoniDL'}
              >
                {deposit.fundNameAtEmployer}
              </Typography>
              <Typography
                textAlign={'right'}
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'Montserrat'}
              >
                {extractFundNumber(deposit?.fundIdentifier) === 0
                  ? deposit?.companyId
                  : extractFundNumber(deposit?.fundIdentifier)}
              </Typography>
            </Box>
            <Typography
              textAlign={'right'}
              fontWeight={'700'}
              fontSize={'35px'}
              fontFamily={'Montserrat'}
            >
              {formatMoney(deposit.totalDepositAmount)}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
            flexDirection: 'row-reverse',
          }}
        >
          {deposit?.paymentMethodCode !== '6' ? (
            <BankInfo fundNumber={deposit?.fundIdentifier} />
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#F3F3F3',
                py: '10px',
                px: '20px',
                borderRadius: '5px',
                flex: 1,
                alignItems: 'flex-start',
                gap: '6px',
              }}
            >
              <Typography
                fontWeight={'600'}
                fontSize={'12px'}
                fontFamily={'Montserrat'}
                textAlign={'right'}
                dir="rtl"
              >
                תשלום באמצעות הוראת קבע
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <PaymentSidebar
        open={sidebarOpen}
        onClose={handleClosePaymentSidebar}
        depositId={deposit.id}
      />
    </>
  );
};
export default PaymentItem;
